<template>
  <div class="section-category section-full section-split">
    <div class="bill-split bill-left">
      <div class="bill-header">
        <div class="bill-table-room">
          <translate>table/room</translate>
          <input-pad
              :item="firstBill"
              :property="useTableOrRoom"
              :alphabetable="true"
              :attributes="{'class': 'form-control'}" />
        </div>
        <div class="bill-staff">
          <translate>staff</translate>
          <input-pad
              :item="staffRef"
              :property="'firstBill'"
              :attributes="{'class': 'form-control'}" />
        </div>
        <div class="bill-table-room">
          <translate>cover</translate>
          <input-pad
              :item="firstBill"
              :property="'cover'"
              :attributes="{'class': 'form-control'}" />
        </div>
        <div class="bill-customer">
          <v-select
            :class="{'no-show': !showDropdown}"
            v-model="firstBill.customer"
            :filterable="false"
            :options="customers"
            :ref="'customer1'"
            :placeholder="$gettext('choose customer')"
            @search:focus="onFocus('customer1')"
            @search="onSearch">
            <template slot="no-options">
              <translate>no results found</translate> ..
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.label }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <div class="bill-list">
        <table class="table">
          <thead>
            <th class="bg-cash" v-translate>Qty</th>
            <th class="bg-cash" v-translate>Item</th>
            <th class="bg-cash" v-translate>Price</th>
            <th class="bg-cash" v-translate>Amount</th>
          </thead>
          <tbody>
            <template v-for="item in firstBill.billItems">
              <bill-item
                :view="'split'"
                :class="{'selected': item == selectedItem}"
                :item="item"
                @click.native="select(item)" />
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="bill-split-middle">
      <img src="/assets/img/logo-pos.png">
      <div class="ferry-step">
        <div class="ferry" @click="move(MOVE_RIGHT, MOVE_STEP)"><icon name="split-arrow"/></div>
        <div class="ferry" @click="move(MOVE_LEFT, MOVE_STEP)"><icon name="split-arrow"/></div>
      </div>
      <div class="ferry-all">
        <div class="ferry" @click="move(MOVE_RIGHT, MOVE_ALL)"><icon name="split-arrow"/><icon name="split-arrow"/></div>
        <div class="ferry" @click="move(MOVE_LEFT, MOVE_ALL)"><icon name="split-arrow"/><icon name="split-arrow"/></div>
      </div>
      <div class="actions">
        <button :disabled="firstBill.billItems.length === 0 || secondBill.billItems.length === 0" class="btn btn-confirm" @click="save()" v-translate>confirm</button>
        <button class="btn btn-cancel" @click="$router.push('order')" v-translate>cancel</button>
      </div>
    </div>
    <div class="bill-split bill-right">
      <div class="bill-header">
        <div class="bill-table-room">
          <translate>table/room</translate>
          <input-pad
            :item="secondBill"
            :alphabetable="true"
            :property="useTableOrRoom"
            :attributes="{'class': 'form-control'}" />
        </div>
        <div class="bill-staff">
          <translate>staff</translate>
          <input-pad
            :item="staffRef"
            :property="'secondBill'"
            :attributes="{'class': 'form-control'}" />
        </div>
        <div class="bill-table-room">
          <translate>cover</translate>
          <input-pad
              :item="secondBill"
              :property="'cover'"
              :attributes="{'class': 'form-control'}" />
        </div>
        <div class="bill-customer">
          <v-select
            :class="{'no-show': !showDropdown}"
            v-model="secondBill.customer"
            :filterable="false"
            :options="customers"
            :ref="'customer2'"
            :placeholder="$gettext('choose customer')"
            @search:focus="onFocus('customer2')"
            @search="onSearch">
            <template slot="no-options">
              <translate>no results found</translate> ..
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.label }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <div class="bill-list">
        <table class="table">
          <thead>
            <th class="bg-cash" v-translate>Qty</th>
            <th class="bg-cash" v-translate>Item</th>
            <th class="bg-cash" v-translate>Price</th>
            <th class="bg-cash" v-translate>Amount</th>
          </thead>
          <tbody>
            <template v-for="item in secondBill.billItems">
              <bill-item
                :view="'split'"
                :class="{'selected': item == selectedItem}"
                :item="item"
                @click.native="select(item)" />
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { TOGGLE_BILL_MODAL_VISIBLE, SET_MESSAGE_MODAL } from '@/store/mutation-types';
import CustomerService from '@/services/CustomerService';
import BillService from '@/services/BillService';
import BillItem from '@/components/BillItem';

export default {
  name: 'SplitBill',
  props: ['originBill'],
  components: {
    BillItem,
  },
  data() {
    return {
      firstBill: { billItems: [] },
      secondBill: { billItems: [] },
      MOVE_LEFT: true,
      MOVE_RIGHT: false,
      MOVE_STEP: true,
      MOVE_ALL: false,
      showDropdown: false,
      customers: [],
      useTableOrRoom: 'table',
      selectedItem: null,
      staffRef: {
        firstBill: 0,
        secondBill: 0
      },
      searchTimeout: null
    };
  },
  computed: {
    bill() { return this.getMap('bill', true); },
    previousOrder() { return this.getMap('previousOrder', true); },
    billModal: {
      get() { return this.getMap('billModal', true); },
      set(value) { this.$store.state.bill.billModal = value; },
    },
    ...mapGetters([
      'getMixersOfItem', 
      'getCommissionOfItem'
    ]),
  },
  methods: {
    select(item) {
      if (item.type == this.COMMISSION_ITEM) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Can not move commission'));
        return;
      }
      this.selectedItem = item;
    },
    move(direction, mode) {
      if (!this.selectedItem) return;
      const item = this.selectedItem;
      const fromBill = direction ? this.secondBill : this.firstBill;
      const toBill = direction ? this.firstBill : this.secondBill;
      const minQuantity = item.qty > 0 ? 1 : -1;

      if (item.type == this.NORMAL_ITEM) {
        this.moveNormalItem(item, fromBill, toBill, minQuantity, mode);
      }

      if (item.type == this.MIXER_ITEM) {
        this.moveMixerItem(item, fromBill, toBill, minQuantity, mode);
      }
      if (item.qty == 0) {
        this.selectedItem = null;
      }
    },
    moveMixerItem(item, fromBill, toBill, minQuantity, mode) {
      const parentSibling = toBill.billItems.find(i => i.id === item.parent);
      if (!parentSibling) return;
      if (item.qty === minQuantity || mode === this.MOVE_ALL) {
        this.moveItem(fromBill, toBill, item, item.qty, parentSibling);
      } else {
        this.moveItem(fromBill, toBill, item, minQuantity, parentSibling);
      }
    },
    moveNormalItem(item, fromBill, toBill, minQuantity, mode) {
      const mixers = this.getMixersOfItem(item, fromBill.billItems);
      const commission = this.getCommissionOfItem(item, null, fromBill.billItems);
      const itemId = item.id;

      if (item.qty === minQuantity || mode === this.MOVE_ALL) {
        const result = this.moveItem(fromBill, toBill, item, item.qty);
        if (!result) return;
        const itemSibling = toBill.billItems.find(i => i.id === itemId);
        mixers.forEach((mixer) => {
          this.moveItem(fromBill, toBill, mixer, mixer.qty, itemSibling);
        });
        if (commission) {
          this.moveItem(fromBill, toBill, commission, commission.qty, itemSibling);
        }
      } else {
        const result = this.moveItem(fromBill, toBill, item, minQuantity);
        if (!result) return;
        if (commission) {
          const itemSibling = toBill.billItems.find(i => i.id === itemId);
          this.moveItem(fromBill, toBill, commission, minQuantity, itemSibling);
        }
      }
    },
    moveItem(fromBill, toBill, item, qty, parent = null) {
      if (item.type == this.NORMAL_ITEM) {
        // check quantity of product not < 0 on both bills
        const result = this.checkCreditBack(fromBill, item, qty, -1)
                        && this.checkCreditBack(toBill, item, qty, 1);
        if (!result) return false;
      }
      const itemSibling = toBill.billItems.find(i => i.id === item.id);
      if (itemSibling) {
        itemSibling.qty += qty;
        if (itemSibling.type == this.COMMISSION_ITEM
            && itemSibling.commissionIncludePrice) {
        } else {
          itemSibling.total = itemSibling.price * itemSibling.qty;
        }
      } else {
        const clone = JSON.parse(JSON.stringify(item));
        clone.qty = qty;
        if (clone.type == this.COMMISSION_ITEM
            && clone.commissionIncludePrice) {
        } else {
          clone.total = clone.price * clone.qty;
        }
        let parentIndex = toBill.billItems.length - 1;
        if (parent) {
          parentIndex = toBill.billItems.indexOf(parent);
        }
        toBill.billItems.splice(parentIndex + 1, 0, clone);
      }
      item.qty -= qty;
      if (item.type == this.COMMISSION_ITEM
            && item.commissionIncludePrice) {
      } else {
        item.total = item.price * item.qty;
      }
      if (item.qty == 0) {
        const index = fromBill.billItems.indexOf(item);
        fromBill.billItems.splice(index, 1);
      }
      return true;
    },
    checkCreditBack(bill, item, qty, direction) {
      let count = 0;
      bill.billItems.forEach((billItem) => {
        if (
          billItem.type == this.NORMAL_ITEM
          && billItem.product == item.product) {
          count += billItem.qty;
        }
      });
      if ((count + direction * qty) < 0) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('invalid credit back'));
        return false;
      }
      return true;
    },
    async save() {
      this.calMargin(this.firstBill);
      this.calMargin(this.secondBill);
      if(this.secondBill.customer) {
        this.secondBill.customer = this.secondBill.customer.value;
      }
      if(this.firstBill.customer) {
        this.firstBill.customer = this.firstBill.customer.value;
      }
      const result = await BillService.splitBill(
        { 
          oldBillId: this.originBill.id,
          firstBill: this.firstBill,
          secondBill: this.secondBill
        }
      );
      if(!result || !result.insert) return;
      this.$store.dispatch('setSplittedBill', result.insert);
    },
    onSearch(search, loading) {
      const _this = this;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        loading(true);
        CustomerService.search(search).then((result) => {
          const transformedCustomers = [];
          result.forEach((customer) => {
            transformedCustomers.push({
              label: customer.name,
              value: customer.id,
            });
          });
          _this.customers = transformedCustomers;
          loading(false);
        });
      }, 500);
    },
    onFocus(ref) {
      this.showDropdown = this.$refs[ref].mutableOptions.length > 0;
    },
  },
  created() {
    if (!this.originBill) {
      this.$router.push('order');
      return;
    }
    if (this.originBill.table === '') {
      this.useTableOrRoom = 'room';
    }
    this.firstBill = Object.assign({}, this.originBill);
    this.firstBill.billItems = JSON.parse(JSON.stringify(this.previousOrder));
    this.secondBill = Object.assign({}, this.originBill);
    this.secondBill.billItems = [];
    this.staffRef.firstBill = this.getObject(this.firstBill.staff, 'staffs').ref;
    this.staffRef.secondBill = this.getObject(this.firstBill.staff, 'staffs').ref;
  },
};
</script>

<style lang="scss" scoped>
</style>
